import { UseToastOptions } from "@chakra-ui/react";

export const getToast = (
  description: string,
  status: UseToastOptions["status"] = "error",
  title = "Error"
): UseToastOptions => {
  return { title, status, position: "top-right", description, duration: 1500 };
};

export const showDate = (date?: Date) => {
  return date ? new Date(date).toLocaleDateString("vi-VN") : "";
};

export const showDate1 = (date?: Date | string | number) => {
  if (!date) return "";
  return new Date(date).toISOString().slice(0, 10);
};

export const getUrlFileDownload = () => {
  return process.env.REACT_FILE_DOWNLOAD;
};


export const getSubDomain = () => {
  return process.env.REACT_APP_PUBLIC_URL;
}

export const subFilename = (filename: string) => {
  const maxLength = 10;

  if (filename.length <= maxLength) return filename;
  const last = filename.lastIndexOf(".");
  const str = filename.slice(0, last);
  const fileType = filename.split(".")[1];
  return `${str.substring(0, maxLength)}***.${fileType}`;
};

export const numberFormat = (number: number | string) =>
  new Intl.NumberFormat().format(Number(number));
